import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Pagination, Alert, Spinner } from "react-bootstrap";
import HelperFunction from '../util/helper'
import { SYSTEM_DEFAULTS } from '../util/constants'
import { useSharedData } from "../context/sharedDataContext";


export default function DashboardSummary() {
    const { summery, loading } = useSharedData();
    const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));

    if(loading) {
        return <div className="d-flex justify-content-center my-5">
                    <Spinner animation="border" />
                </div>
    }
    const { total } = HelperFunction.totalPackages(summery)
    const bamba = HelperFunction.getPackageDetails(summery, 'BAMBA')
    const imarika = HelperFunction.getPackageDetails(summery, 'IMARIKA')
    const milele = HelperFunction.getPackageDetails(summery, 'MILELE')

    return (
        <Row>
            <>
                {/* Balance Card */}
                <Col md={4} className="mb-4">
                    <Card className="balance-card">
                    <Card.Body>
                        <div className="balance-header">
                        <span className="balance-icon">
                            <h3 className="user-name-card">{storedUser?.first_name ?? 'Missing name'}</h3>
                        </span>
                        <span className="wifi-icon">
                            <img
                            src="/images/logo.svg"
                            alt="wengmack"
                            className="img-fluid dashboard-logo"
                            /></span>
                        </div>
                        <div className="balance-info">
                        <span className="balance-label">Balance Amount</span>
                        <h2 className="balance-amount">{HelperFunction.formatCurrency(total)}</h2>
                        <div className="card-details"></div>
                        </div>
                    </Card.Body>
                    </Card>
                </Col>

                {/* Stats Cards */}
                <Col md={8}>
                    <Row>
                    <Col sm={4} className="mb-3">
                        <Card className="stat-card income-card">
                        <Card.Body>
                            <div className="stat-header">
                            <span className="stat-icon"><i className="bi bi-person"></i></span>
                            <span className="stat-change positive">{HelperFunction.getPercent(parseFloat(bamba.total_sum), parseFloat(bamba.target_sum))}%</span>
                            </div>
                            <h3>{HelperFunction.formatCurrency(bamba.total_sum)}</h3>
                            <p>Bamba Plan</p>
                        </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={4} className="mb-3">
                        <Card className="stat-card expense-card">
                        <Card.Body>
                            <div className="stat-header">
                            <span className="stat-icon"><i className="bi bi-people"></i></span>
                            <span className="stat-change positive">{HelperFunction.getPercent(parseFloat(imarika.total_sum), parseFloat(imarika.target_sum))}%</span>
                            </div>
                            <h3>{HelperFunction.formatCurrency(imarika.total_sum)}</h3>
                            <p>Imarika Plan</p>
                        </Card.Body>
                        </Card>
                    </Col>
                    <Col sm={4} className="mb-3">
                        <Card className="stat-card savings-card">
                        <Card.Body>
                            <div className="stat-header">
                            <span className="stat-icon"><i className="bi bi-building"></i></span>
                            <span className="stat-change positive">{HelperFunction.getPercent(parseFloat(milele.total_sum), parseFloat(milele.target_sum))}%</span>
                            </div>
                            <h3>{HelperFunction.formatCurrency(milele.total_sum)}</h3>
                            <p>Milele Plan</p>
                        </Card.Body>
                        </Card>
                    </Col>
                    </Row>
                </Col>
            </>
        </Row>
    )
}